export default __webpack_public_path__ + "static/media/background.a5c4d65a.jpg";